<template>
	<div class="container">
		<NoticeNav/>
		<div class="clearfix"></div>
		<div class="notice-title">{{noticeInfo.title}}</div>
		<div class="notice-time">{{noticeInfo.addTimeStr}}</div>
		<div class="notice-content" v-html="noticeInfo.content">
			
		</div>
	</div>
</template>

<script>
import NoticeNav from '@/components/NoticeNav'
import qs from 'qs'
import { post,ajaxParam } from '@/units/request.js'
export default {
  name: 'NoticeDetail',
  data(){
	return{
		id: '',
		noticeInfo: {}
	}
  },
  components: {
	NoticeNav
  },
  methods: {
	//获取公告详情
	async getNoticeInfo(){
		let url = 'v1/notice/info'
		let param = {
			id: this.id
		}
		ajaxParam(param)
		const res = await post(url, qs.stringify(param))
		if(res.data.code==200) {
			console.log('------')
			this.noticeInfo = res.data.entity
		} else {
			this.$message.error(res.data.msg)
		}
	}
  },
  created(){
	window.scrollTo(0, 0)
	this.id = this.$route.params.id
	console.log(this.id)
	if(this.id){
		this.getNoticeInfo()
	}
  }
}
</script>

<style scoped>
	.container{
		width: 1028px;
		margin: 0 auto;
	}
	.notice-content{
		min-height: 300px;
		padding: 20px;
		overflow-x: hidden
	}
	.notice-title{
		margin-top: 30px;
		margin-bottom: 5px;
		text-align: center;
		font-size: 18px;
		line-height: 25px;
		font-weight: 500;
	}
	.notice-time{
		text-align: center;
		font-size: 12px;
	}
</style>
